import React, { useState, useContext, useEffect } from "react";
import CssTransition from "../../component/layout/css-transition";

function ApproveTransfer({ openTransferModal, setOpenTransferModal, handleAccept, id }) {

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={openTransferModal}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={openTransferModal}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div className="bg-white rounded-md shadow-lg overflow-auto max-w-lg w-full max-h-full">
          <div class="p-3 flex space-x-4 ">
            <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-rose-100">
              <svg
                className={`w-4 h-4 shrink-0 fill-current text-green-500`}
                viewBox="0 0 16 16"
              >
                <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
              </svg>
            </div>
            <div className="flex-grow">
              <div className="mb-2">
                <h4 className="text-lg font-semibold text-slate-800">
                  Accept Transfer Request
                </h4>
              </div>
              <div className="text-sm mb-10">
                <div className="space-y-2">
                  <p>Are you sure you want to accept this transfer request?</p>
                </div>
              </div>
              <div className="flex flex-wrap justify-end space-x-2">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenTransferModal(!openTransferModal);
                  }}
                  className="btn-sm border-slate-200 hover:border-slate-300 text-slate-600"
                >
                  Cancel
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleAccept(id);
                  }}
                  className="btn-sm !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default ApproveTransfer;
